class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.sliderRangeBar = this.querySelector('.slider-range-bar');

    this.inputs = this.querySelectorAll('input') || false;
    this.labels = this.querySelectorAll('label > span') || false;

    this.from = {
      min: parseInt(this.inputs[0].getAttribute('min') || 0),
      max: parseInt(this.inputs[0].getAttribute('max') || 0),
      value: parseInt(this.inputs[0].value || 0)
    }

    this.to = {
      min: parseInt(this.inputs[1].getAttribute('min') || 0),
      max: parseInt(this.inputs[1].getAttribute('max') || 0),
      value: parseInt(this.inputs[1].value || 0)
    }

    if(this.inputs) {
      this.inputs.forEach((element) => {
        element.addEventListener('input', (event) => {
          this.onRangeInput(event);
        });
      });
      this.moveSliderRangeColor();
    }
  }

  /**
   * onRangeInput
   * @description Handles the input event for range inputs
   */
  onRangeInput(event) {
    this.updateScopedMinAndMaxValues();
    this.setMinAndMaxValues(event.currentTarget);
  }

  /**
   * setMinAndMaxValues
   * @param {*} input
   * @description Set the input values
   */
  setMinAndMaxValues(input) {
    const role = input.dataset.rangeRole;

    if (role == 'from') {
      if(parseInt(input.value) > this.to.value) {
        input.value = this.to.value - 1;
        return;
      }
    } else if (role == 'to') {
      if(parseInt(input.value) < this.from.value) {
        input.value = this.from.value + 1;
        return;
      }
    }

    // Update range slider visuals
    this.moveSliderRangeColor();
    this.updateLabelValues();
  }

  updateScopedMinAndMaxValues() {
    this.from.value = parseInt(this.inputs[0].value || 0);
    this.to.value = parseInt(this.inputs[1].value || 0);
  }

  updateLabelValues() {
    this.labels[0].innerText = this.from.value;
    this.labels[1].innerText = this.to.value;
  }

  moveSliderRangeColor() {

    // Guard: return if sliderRangeBar is undefined
    if(!this.sliderRangeBar) return

    const sliderRange = this.to.max - this.from.min;
    const thumbOnePos = (this.from.value / sliderRange) * 100;
    const thumbTwoPos = (this.to.value / sliderRange) * 100;

    this.sliderRangeBar.style.left = `${thumbOnePos}%`;
    this.sliderRangeBar.style.width = `${thumbTwoPos - thumbOnePos}%`;
  }
}

if (!customElements.get('price-range')) {
  customElements.define('price-range', PriceRange);
}
